/* Local dependencies */
import {
  GetSingleSignedUrlsInput,
  ResetSignedUrls,
  ResetSignedUrlsError,
  SignedUrl,
  SignedUrls,
  SignedUrlsError,
  SignedUrlsSuccess,
  SignedUrlTypes,
} from './type';

export function signedUrls(input: GetSingleSignedUrlsInput): SignedUrls {
  return {
    type: SignedUrlTypes.SIGNED_URLS_REQUEST,
    input,
  };
}

export function signedUrlsSuccess(signedUrls: SignedUrl[]): SignedUrlsSuccess {
  return {
    type: SignedUrlTypes.SIGNED_URLS_SUCCESS,
    signedUrls,
  };
}

export function signedUrlsError(error: Error): SignedUrlsError {
  return {
    type: SignedUrlTypes.SIGNED_URLS_ERROR,
    error,
  };
}

export function resetSignedUrls(): ResetSignedUrls {
  return {
    type: SignedUrlTypes.RESET_SIGNED_URLS,
  };
}

export function resetSignedUrlsError(): ResetSignedUrlsError {
  return {
    type: SignedUrlTypes.RESET_SIGNED_URLS_ERROR,
  };
}
